// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import styled, { css } from 'styled-components';

const Button = styled.button<{ $type?: 'primary' | 'secondary' | 'link' }>`
  background: linear-gradient(93deg, #f46800 0%, #ff8833 100%);
  color: ${({ theme }) => theme.colors.ink};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  padding: 13px 28px;
  min-height: 48px;
  outline: none;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  border-radius: 999px;
  cursor: pointer;
  text-decoration: none;
  transition: box-shadow 0.15s ease, transform 0.15s ease, filter 0.15s ease;

  &:hover {
    filter: brightness(1.06);
    box-shadow: 0 4px 16px rgba(244, 104, 0, 0.35);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.ink};
    outline-offset: 2px;
  }

  &:disabled {
    filter: grayscale(0.4);
    opacity: 0.55;
    cursor: wait;
    box-shadow: none;
  }

  ${({ $type = 'primary' }) =>
    $type === 'secondary' &&
    css`
      background: none;
      color: ${({ theme }) => theme.colors.ink};
      border: 1px solid ${({ theme }) => theme.colors.ink};

      &:hover {
        filter: none;
        box-shadow: none;
        background: ${({ theme }) => theme.colors.surfaceMuted};
      }
    `};

  ${({ $type = 'primary' }) =>
    $type === 'link' &&
    css`
      background: none;
      color: ${({ theme }) => theme.colors.grafanaOrange};
      border: none;

      &:hover {
        filter: none;
        box-shadow: none;
        text-decoration: underline;
      }
    `};
`;

export default Button;
